var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemoveFromCompare = function SvgRemoveFromCompare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 10h10c.55 0 1 .45 1 1s-.45 1-1 1h-10c-.55 0-1-.45-1-1s.45-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 6h10c.55 0 1 .45 1 1s-.45 1-1 1h-10c-.55 0-1-.45-1-1s.45-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 16h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.306 15.7836c-.408-.408-.408-1.0696 0-1.4776s1.0696-.408 1.4776 0l2.2165 2.2165 2.2165-2.2165c.408-.408 1.0695-.408 1.4776 0 .408.4081.408 1.0696 0 1.4776l-2.2165 2.2165 2.2162 2.2162c.4081.4081.4081 1.0696 0 1.4776-.408.408-1.0695.4081-1.4776 0l-2.2162-2.2162-2.2163 2.2163c-.408.408-1.0695.408-1.4776 0-.408-.4081-.408-1.0696 0-1.4776l2.2163-2.2163z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveFromCompare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove_from_compare.3820edfe.svg";
export { ForwardRef as ReactComponent };